import classes from './CommonButton.module.css'

const CommonButton = ({title, className, style, onClick, disable, type, icon}) => {
    return(
        <button className={`d-flex align-items-center justify-content-center ${classes.wrapper} ${disable ? classes.disableButton : ""} ${className}`} style={style} role={!disable && 'button'} onClick={onClick} type={type}>{icon}{title}</button>
    )
}

export default CommonButton